module.exports = __webpack_public_path__ + "static/media/shrink-poster.37797eca.png";